import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe('pk_test_51OHYH0BWGJihMgNLb0fTamqmfblH60es8rzShPHgKTH4XBBiikw3PGlJpKDC6LE122i00J1cuAq8QJt8sd1ppSDw00UfqT34pN');

const StripeContainer = ({ userId, onSuccess }) => {
  return (
    <Elements stripe={stripePromise}>
      <div className="flex items-center justify-center min-h-screen bg-[#FAFAFA] p-4">
        <CheckoutForm userId={userId} onSuccess={onSuccess} />
      </div>
    </Elements>
  );
};

export default StripeContainer;
